import {
  CANDIDATES_ALREADY_SENT_FETCHING,
  CANDIDATES_ALREADY_SENT_FAILED,
  CANDIDATES_ALREADY_SENT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CANDIDATES_ALREADY_SENT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case CANDIDATES_ALREADY_SENT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case CANDIDATES_ALREADY_SENT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
